export enum StringBoolean {
  Yes = "yes",
  No = "no",
  True = "true",
  False = "false",
}

export function BooleanToString(value: boolean): string {
  return value ? "yes" : "no";
}

export function StringToBoolean(value: string): boolean {
  return value === StringBoolean.Yes;
}